module.exports = __webpack_public_path__ + "static/media/Pokeball.6afdf96c.svg";